
import React, { useEffect } from 'react'
import BookingDetailsTbo from '../bookingpagestbo/BookingDetailsTbo'
import { useLocation, useNavigate } from 'react-router-dom';
import BookingDetailsTripJack from '../bookingpagetripJack/BookingDetailsTripJack';

const TripjeckTBOReviewPage = () => {
    let location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const navType = window.performance.getEntriesByType("navigation")[0]?.type;
        if (!location?.state?.vendorType) {
            navigate('/', { replace: true });
            return;
        }

        if (navType === "back_forward" && location?.state?.vendorType === "TBO") {
            window.location.reload();
        }
    }, [location, navigate]);


    return (
        <>
            {location?.state?.vendorType === "TripJack" && <BookingDetailsTripJack location={location} />}
            {location?.state?.vendorType === "TBO" && <BookingDetailsTbo location={location} />}
        </>
    )
}

export default TripjeckTBOReviewPage